/* eslint-env browser */

const productTileHelper = require('./helpers/productTile');

const SELECTORS = {
  recommendationSlot: [
    '.tfg-recommendations',
    '[id^="cq_recomm_slot"]',
    '[data-cnstrc-recommendations]',
    '.style_with_product_recs_container',
  ].join(', '),
  tileItem: '.product-detail__tile-row__item',
  productTile: '.product-tile',
};

const ATTRS = {
  numResults: 'data-cnstrc-num-results',
  strategyId: 'data-strategy-id',
  tracking: 'data-tracking',
  constructorItem: 'data-cnstrc-item',
  itemId: 'data-cnstrc-item-id',
  itemName: 'data-cnstrc-item-name',
  itemPrice: 'data-cnstrc-item-price',
  itemSection: 'data-cnstrc-item-section',
  constructorStrategyId: 'data-cnstrc-strategy-id',
};

const EVENTS = {
  overlayToggle: 'tile:overlay-toggle',
};

const CONSTRUCTOR_ITEM_TYPE = 'recommendation';
const CONSTRUCTOR_ITEM_SECTION = 'Products';

function parseTrackingData(tile) {
  const trackingDataRaw = tile.getAttribute(ATTRS.tracking);

  if (!trackingDataRaw) return null;

  try {
    return JSON.parse(trackingDataRaw);
  } catch (e) {
    window.console.warn('Constructor: Failed to parse item data', e);
    return null;
  }
}

function setAttribute(element, attr, value) {
  if (value !== null && value !== undefined && value !== '') {
    element.setAttribute(attr, value);
  }
}

function setSlotResultCount(slot, itemsCount) {
  if (!slot.hasAttribute(ATTRS.numResults)) {
    slot.setAttribute(ATTRS.numResults, itemsCount);
  }
}

function setTileConstructorAttributes(tile, productData, strategyId) {
  tile.setAttribute(ATTRS.constructorItem, CONSTRUCTOR_ITEM_TYPE);

  if (!productData) return;

  setAttribute(tile, ATTRS.itemId, productData.id);
  setAttribute(tile, ATTRS.itemName, productData.name);
  setAttribute(tile, ATTRS.itemPrice, productData.price);
  setAttribute(tile, ATTRS.itemSection, CONSTRUCTOR_ITEM_SECTION);

  if (strategyId) {
    setAttribute(tile, ATTRS.constructorStrategyId, strategyId);
  }
}

function decorateTile(tile, strategyId) {
  if (!tile || tile.hasAttribute(ATTRS.constructorItem)) return;

  const tracking = parseTrackingData(tile);
  const productData = tracking && tracking.item;

  if (!productData) return;

  setTileConstructorAttributes(tile, productData, strategyId);
  productTileHelper.syncBtnAttrs(tile);
}

/**
 * Decorates recommendation slot tiles with Constructor data attributes.
 *
 * @param {Element} slot - Recommendation container
 */
function decorateConstructorItems(slot) {
  if (!slot) return;

  const items = slot.querySelectorAll(SELECTORS.tileItem);

  if (!items.length) return;

  setSlotResultCount(slot, items.length);

  const strategyId = slot.getAttribute(ATTRS.strategyId);

  items.forEach((itemContainer) => {
    const tile = itemContainer.querySelector(SELECTORS.productTile);
    decorateTile(tile, strategyId);
  });
}

/**
 * Decorates all recommendation slots currently available on the page.
 */
function decorateAllRecommendationSlots() {
  const slots = document.querySelectorAll(SELECTORS.recommendationSlot);

  slots.forEach(decorateConstructorItems);
}

/**
 * Initializes observer for dynamically loaded recommendation slots.
 */
function initConstructorTracking() {
  decorateAllRecommendationSlots();

  const observer = new MutationObserver(decorateAllRecommendationSlots);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initRecommendationEvents() {
  document.addEventListener(EVENTS.overlayToggle, (event) => {
    const detail = event.detail || {};

    if (detail.shown && detail.tile) {
      productTileHelper.bindPLPSizeSelection(detail.tile);
    }
  });
}

module.exports = function () {
  initConstructorTracking();
  initRecommendationEvents();
};
